import React, { useMemo } from "react";
import InfiniteScrollWithoutFetch from "src/components/InfiniteScrollWithoutFetch";
import IComponentListCards from "./interface";
import DivGrouper from "./styles";

const ListCards: React.FC<IComponentListCards> = ({
	data,
	mapper,
	filter,
	manuallyToggleShowMore
}) => {

	const ListCardsElement = useMemo(() => (
		<InfiniteScrollWithoutFetch
			listElements={data}
			mapper={mapper}
			filter={filter}
			manuallyToggleShowMore={manuallyToggleShowMore}
		/>
	), [data, filter]);

	return(
		<DivGrouper>
			{ListCardsElement}
		</DivGrouper>
	);
};

export default ListCards;
